import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import "./Staff.css";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import axios from "axios";
import Loader from "react-loader-spinner";

// Truncate long text
const truncate = (text, length = 130) => {
  if (!text) return "";
  return text.length > length ? text.substring(0, length) + "…" : text;
};

export default class Staff extends Component {
  state = {
    profiles: [],
    loading: true,
    error: false,
  };

  componentDidMount() {
    axios
      .get("/v1/api/profile")
      .then((res) =>
        this.setState({ profiles: res.data, loading: false })
      )
      .catch((err) => {
        console.error("Staff API failed:", err);
        this.setState({ error: true, loading: false });
      });
  }

  render() {
    const { profiles, loading, error } = this.state;

    return (
      <div className="App">
        <Header />

        <Banner page="Our Team" pageName="Staff" />

        <section className="fsm-section fsm-staff">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Meet Us</span>
              <h2>Our People</h2>
              <p>
                The men and women serving across FSM's missions, training,
                media, and support ministries.
              </p>
            </div>

            {loading && (
              <div className="fsm-loader">
                <Loader
                  type="TailSpin"
                  color="#E32227"
                  height={70}
                  width={70}
                />
              </div>
            )}

            {error && !loading && (
              <div className="fsm-empty-state">
                <h3>Unable to load staff</h3>
                <p>Please check your connection and try again.</p>
              </div>
            )}

            {!loading && !error && profiles.length === 0 && (
              <div className="fsm-empty-state">
                <h3>No staff to display</h3>
              </div>
            )}

            {!loading && !error && profiles.length > 0 && (
              <div className="fsm-staff-grid">
                {profiles.map((profile) => (
                  <Link
                    to={`/staff/${profile.id}`}
                    className="fsm-staff-card"
                    key={profile.id}
                  >
                    <div className="fsm-staff-img">
                      <img
                        src={profile.image}
                        alt={profile.full_name}
                        loading="lazy"
                      />
                    </div>

                    <div className="fsm-staff-body">
                      <h3>{profile.full_name}</h3>
                      <span className="fsm-staff-position">
                        {profile.position}
                      </span>
                      <p>{truncate(profile.about)}</p>

                      <div className="fsm-staff-bottom">
                        <span className="fsm-staff-link">
                          View Profile <span aria-hidden="true">→</span>
                        </span>

                        <div className="fsm-staff-socials">
                          {profile.facebook_link && (
                            <span
                              className="fsm-staff-social"
                              aria-label="Facebook"
                            >
                              <i className="fa fa-facebook"></i>
                            </span>
                          )}
                          {profile.twitter_link && (
                            <span
                              className="fsm-staff-social"
                              aria-label="Twitter"
                            >
                              <i className="fa fa-twitter"></i>
                            </span>
                          )}
                          {profile.instagram_link && (
                            <span
                              className="fsm-staff-social"
                              aria-label="Instagram"
                            >
                              <i className="fa fa-instagram"></i>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}